import { errorLogs } from "./firebase";

const RATE_WINDOW_MS = 60 * 1000;
const RATE_LIMIT = 5;
const MAX_TRACKED_KEYS = 200;
const recentLogTimestamps = new Map();

export async function errorLogsWrapper({ module = '', description = '', errorDetails = null, context = null, createdBy = '-' }) {
  const key = `${module}::${errorDetails?.message || description}`;
  const now = Date.now();

  let timestamps = recentLogTimestamps.get(key) || [];
  timestamps = timestamps.filter((ts) => now - ts < RATE_WINDOW_MS);
  if (timestamps.length >= RATE_LIMIT) {
    recentLogTimestamps.set(key, timestamps);
    return;
  }
  timestamps.push(now);
  recentLogTimestamps.set(key, timestamps);

  if (recentLogTimestamps.size > MAX_TRACKED_KEYS) {
    recentLogTimestamps.delete(recentLogTimestamps.keys().next().value);
  }

  try {
    await errorLogs.add({
      module,
      description,
      errorDetails: errorDetails ? JSON.parse(JSON.stringify(errorDetails)) : null,
      context: context ? JSON.parse(JSON.stringify(context)) : null,
      createdBy,
      createdAt: new Date().toISOString()
    });
  } catch (logError) {
    console.error("Failed to log to errorLogs:", logError);
  }
}
